import React from 'react'
import { withStyles, List, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import elements from './mock.elements'
import ListElement from './ListElement';

const style = theme => ({
	root: {

	}
})

function MyCriteriaList({
	classes,
	formikProps,
}) {

	const handleClick = item => {
		formikProps.setValues({
			...formikProps.values,
			...item,
			isSelected: true,
		})
	}

	const errorValue = formikProps.errors.isSelected;
	const touched = formikProps.touched.isSelected;
	const isError = !!errorValue && touched

	return (
		<>
			<List>
				{elements.map((item, i) => {
					return (
						<ListElement {...item} key={i} onClick={() => handleClick(item)} />
					)
				})}
			</List>
			<Typography
				variant='body1'
				color='error'
				align='center'
			>
				{isError && formikProps.errors.isSelected}
			</Typography>
		</>
	)
}

MyCriteriaList.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(MyCriteriaList);